import { useStore } from '@nanostores/react';
import { Button } from '~/components/ui/Button';
import { pricingStore } from '~/lib/stores/pricing/pricing';
import { userStore } from '~/lib/stores/user';
import { PricingPageOpenedTrigger } from '~/types/analytics';
import { classNames } from '~/utils/classNames';

export const NoDatabaseScreen = ({ icon, description }: { icon: string; description: string }) => {
  const activeOrganization = useStore(userStore.getActiveOrganization());

  const isPaidUser = useStore(userStore.isPaidUser);
  const isAdmin = activeOrganization ? isPaidUser && activeOrganization.role === 'admin' : isPaidUser;
  const isTeamMember = activeOrganization && isPaidUser && activeOrganization.role !== 'admin';

  const getTitle = () => {
    if (isAdmin) {
      return 'Ask Bolt to start your database';
    }
    if (isTeamMember) {
      return 'You need an admin to start a database';
    }
    return 'Manage your app’s database';
  };

  const showPricingOverlay = () => {
    pricingStore.openPricingOverlay(PricingPageOpenedTrigger.SettingsDatabaseTab);
  };

  return (
    <div className="flex flex-col gap-3 items-center h-full justify-center">
      <div className="size-16 flex items-center justify-center rounded-full bg-bolt-ds-surfaceTwo">
        <div className={classNames('text-bolt-ds-text-secondary size-8 text-bolt-ds-textTertiary', icon)} />
      </div>
      <div>{getTitle()}</div>
      <div className="text-bolt-ds-text-secondary text-sm text-center max-w-100">{description}</div>
      {!isPaidUser && (
        <Button className="w-min mt-1" onClick={showPricingOverlay}>
          Upgrade to a Pro plan
        </Button>
      )}
    </div>
  );
};
